import { Colors, Utils } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';
import { Column } from '@lightningjs/ui-components';
import PlayButton from './PlayButton';

export default class SubscriptionModal extends Lightning.Component {
  static _template() {
    return {
      Logo: {
        x: 730,
        y: 170,
        w: 470,
        h: 67,
        texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 470, 67),
      },
      Wrapper: {
        zIndex: 200,
        w: 1920,
        h: 1080,
        color: Colors('#000000').get(),
        rect: true,
        collision: true,
        flex: { direction: 'column', alignItems: 'center' },
        Text1: {
          y: 320,
          text: {
            text: 'Oops!',
            textColor: Colors('#fafafa').get(),
            fontFace: 'OpenSans-Regular',
            textAlign: 'center',
            fontSize: 55,
          },
        },
        Text2: {
          y: 320,
          text: {
            text: 'It looks like there is an issue on your account.',
            textColor: Colors('#fafafa').get(),
            fontFace: 'OpenSans-Regular',
            textAlign: 'center',
            fontSize: 36,
          },
        },
        Text3: {
          y: 370,
          text: {
            text: 'To resolve this issue, please update your payment information from your account portal at',
            textColor: Colors('#fafafa').get(),
            fontFace: 'OpenSans-Regular',
            textAlign: 'center',
            fontSize: 36,
            wordWrap: true,
            wordWrapWidth: 1150,
            maxLines: 2,
            lineHeight: 50,
          },
        },
        Text4: {
          y: 360,
          text: {
            text: 'https://stream.livingscriptures.com/update_payment_info',
            textColor: Colors('#02AC25').get(),
            textAlign: 'center',
            fontSize: 36,
            fontFace: 'OpenSans-Regular',
          },
        },
        Text5: {
          y: 410,
          text: {
            text: 'Or contact our customer support team via phone at 800-548-4647. Office hours Monday-Friday 9am-5pm MST.',
            textColor: Colors('#fafafa').get(),
            textAlign: 'center',
            fontSize: 36,
            fontFace: 'OpenSans-Regular',
            wordWrap: true,
            wordWrapWidth: 1150,
            maxLines: 2,
            lineHeight: 50,
          },
        },
        BtnContainer: {
          y: 420,
          w: 235,
          h: 71,
          name: 'Subscription',
          type: PlayButton,
          collision: true,
          zIndex: 300,
          visible: true,
          PlayButton: {
            x: 3,
            y: 3,
            w: 235,
            h: 71,
            type: Column,
            rect: true,
            visible: true,
            color: Colors('#292929').get(),
            shader: { type: Lightning.shaders.RoundedRectangle, radius: 16 },
            Text: {
              x: (235 - 45) / 2,
              y: 12,
              text: {
                fontFace: 'OpenSans-Regular',
                text: 'OK',
                fontSize: 32,
              },
            },
          },
        },
      },
    };
  }

  _getFocused() {
    return this.tag('Wrapper.BtnContainer');
  }

  _handleLeft() {
    return;
  }
  _handleRight() {
    return;
  }
  _handleUp() {
    return;
  }
  _handleDown() {
    return;
  }
  $setState(state) {
    this._setState('Subscription');
  }
  _handleEnter() {
    localStorage.setItem('subscriptionConfirmed', true);
    this.fireAncestors('$hideModal');
  }
  $pressedClick() {
    this._handleEnter();
  }
  _handleBack() {
    this._handleEnter();
  }
}
